import { type Components, type Theme } from '@mui/material/styles';

import { transitions } from '@/theme/constants';

import { height as muiAppBarHeight } from './MuiAppBar';

const MuiDrawer: Components['MuiDrawer'] = {
  styleOverrides: {
    root: ({ theme: { spacing } }: { theme: Theme }) => ({
      transition: transitions.width,
      flexShrink: 0,
      '& .MuiListItem-root': {
        padding: 0
      },
      '& .MuiListItemIcon-root': {
        minWidth: 'inherit',
        color: 'inherit'
      },
      '& .MuiCollapseButton-root': {
        position: 'absolute',
        top: spacing(3),
        zIndex: 10,
        cursor: 'pointer'
      },
      zIndex: 10
    }),
    paper: ({ theme: { spacing } }: { theme: Theme }) => ({
      transition: transitions.width,
      boxSizing: 'border-box',
      marginTop: spacing(muiAppBarHeight),
      overflow: 'visible'
    })
  }
} as never;

export default MuiDrawer;
